const moment = require("moment");
const { HeaderPositionType } = require("../../constants");

const devTemplates = [];

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "StackDiagram",

        allowColorBackgrounds: true,
        allowColorful: false,

        // variations: "stackdiagram",

        defaultData: {
            primary: {
                cols: 12,
                rows: 12,
                items: [{
                    x: 0, y: 0, height: 6, width: 3, showText: true,
                }, {
                    x: 0, y: 6, height: 3, width: 6, showText: true,
                }, {
                    x: 3, y: 0, width: 3, height: 6, showText: true,
                }, {
                    x: 6, y: 0, width: 3, height: 6, showText: true,
                }, {
                    x: 0, y: 9, width: 12, height: 3, showText: true,
                }, {
                    x: 6, y: 6, width: 6, height: 3, showText: true,
                }, {
                    x: 9, y: 0, width: 3, height: 6, showText: true,
                }]
            }
        }
    }), getStaticProps: () => ({
        id: "stackDiagram_sidebyside",
        icon: "stack_sidebyside",
        title: "Stack Diagram",
        description: "",
        category: "diagram",
        tags: "stack structure organization order relationship software architecture services layer group flow diagram platform base system foundation box boxes",
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "StackDiagram",

        allowColorBackgrounds: true,
        allowColorful: false,

        // variations: "stackdiagram",

        defaultData: {
            primary: {
                cols: 12,
                rows: 12,
                items: [{
                    x: 0, y: 0, height: 12, width: 12, showText: true,
                    items: [{}, {}, {}, {}]
                }],
            }
        }
    }), getStaticProps: () => ({
        id: "stackDiagram_contained",
        icon: "stack_contained",
        title: "Contained Boxes",
        description: "",
        category: "diagram",
        tags: "stack structure organization order relationship software architecture services layer group flow diagram platform base system foundation box boxes",
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "StackDiagram",

        allowColorBackgrounds: true,
        allowColorful: false,

        // variations: "stackdiagram",

        defaultData: {
            primary: {
                cols: 12,
                rows: 12,
                items: [{
                    x: 0, y: 0, width: 12, height: 3, showText: true,
                }, {
                    x: 0, y: 3, width: 3, height: 6, showText: true,
                }, {
                    x: 3, y: 3, width: 3, height: 6, showText: true,
                }, {
                    x: 6, y: 3, width: 3, height: 6, showText: true,
                }, {
                    x: 9, y: 3, width: 3, height: 6, showText: true,
                }, {
                    x: 0, y: 9, width: 12, height: 3, showText: true,
                }]
            }
        }
    }), getStaticProps: () => ({
        id: "stackDiagram",
        icon: "stack_architecture",
        title: "Architecture Diagram",
        description: "",
        category: "diagram",
        tags: "stack structure organization order relationship software architecture services layer group flow diagram platform base system foundation box boxes",
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "UserTestimonial",

        allowColorful: true,

        defaultData: {
            primary: {
                showTail: true,
                showDesignQuotes: true,
                frameStyle: "quote-box",
                items: [
                    {
                        quote: "",
                        showAttribution: true,
                        showImage: true,
                        showLogo: true
                    },
                    {
                        quote: "",
                        showAttribution: true,
                        showImage: true,
                        showLogo: true
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "user_testimonial",
        icon: "user_testimonial",
        title: "Quotes",
        subtitle: "",
        description: "Display quotes from your users.",
        category: "people",
        tags: "users user testimonial persona partners partnerships pr press customers problem speaker intros team culture members compete competitors competitor competition messages message make a list items category categories reasons values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished photo photos photographs images pictures services solution key takeaway highlight priority bullet update status points case study landscape call to action image text product features",
        isComingSoon: true
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "Map",

    }), getStaticProps: () => ({
        id: "map_world",
        icon: "map_world",
        title: "World Map",
        description: "",
        category: "people",
        tags: "",
        isComingSoon: true
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "Calendar",

        allowColorBackgrounds: false,

        defaultData: {
            primary: {
                showTitle: false,
                showWeekends: true,
                startOnMonday: false,
                calendarType: "month",
                date: moment().startOf("week").format("MM/DD/YYYY")
            }
        }

    }), getStaticProps: () => ({
        id: "calendar-month",
        icon: "calendar_month",
        title: "Calendar - Month",
        description: "",
        category: "diagram",
        tags: "calendar date week month time day days year tasks schedule events when",
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "Calendar",

        allowColorBackgrounds: false,

        defaultData: {
            primary: {
                showTitle: false,
                showWeekends: true,
                startOnMonday: false,
                calendarType: "week",
                date: moment().startOf("week").format("MM/DD/YYYY")
            }
        }

    }), getStaticProps: () => ({
        id: "calendar-week",
        icon: "calendar_week",
        title: "Calendar - Week",
        description: "",
        category: "diagram",
        tags: "calendar date week month time day days year tasks schedule events when",
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "VerticalTaskLists",

        allowColorBackgrounds: false,

        variations: "tasklist",

        defaultData: {
            primary: {
                items: [{
                    label: "To do",
                    items: [{
                        title: "Task 1"
                    }, {
                        title: "Task 2",
                        color: "accent1",
                        icon: "star"
                    }]
                }, {
                    label: "In progress",
                    items: [{
                        title: "Task 3"
                    }, {
                        title: "Task 4"
                    }]
                }, {
                    label: "Completed",
                    items: [{
                        title: "Task 5",
                        color: "accent1",
                        icon: "star"
                    }]
                }]
            }
        }

    }), getStaticProps: () => ({
        id: "kanban",
        icon: "kanban",
        title: "Kanban Board",
        description: "",
        category: "diagram",
        tags: "kanban project board cards columns tasks progress swimlane team work organize flow process",
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "HorizontalTaskLists",

        allowColorBackgrounds: false,

        variations: "tasklist",

        defaultData: {
            primary: {
                items: [{
                    label: "To do",
                    items: [{
                    }, {
                    }]
                }, {
                    label: "In progress",
                    items: [{
                    }, {
                    }]
                }, {
                    label: "Completed",
                    items: [{
                    }]
                }]
            }
        }

    }), getStaticProps: () => ({
        id: "horizontal-task-list",
        icon: "horizontal-task-list",
        title: "Horizontal Task List",
        description: "",
        category: "diagram",
        tags: "kanban project board cards columns tasks progress swimlane team work organize flow process",
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "DebugBox"
    }), getStaticProps: () => ({
        id: "debug_box",
        icon: "debug_box",
        title: "Debug Box",
        category: "organization",
        tags: "",
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "Embed",

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE,
                showFooter: "off",
            }
        },

        allowHeader: true,
        allowFooter: true,

        allowColorful: false,
    }), getStaticProps: () => ({
        id: "embed",
        icon: "debug_box",
        title: "Fullscreen Embed",
        category: "impact",
        tags: "embed iframe external"
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "Embed"
    }), getStaticProps: () => ({
        id: "embed_title",
        icon: "debug_box",
        title: "Embed with Title",
        category: "impact",
        tags: "embed iframe external",
    })
});

module.exports = devTemplates;
